module.exports = __webpack_public_path__ + "pc-top-assets/img/instagram-black.04f1d872.svg";